module.exports = __webpack_public_path__ + "img/question.c8a9bbb5.png";